import { INICIALITZAR, OMPLIR_TITOL_APARTAT } from "../actions/actionTypes";

const ESTAT_INICIAL = "";

const titolApartat = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case INICIALITZAR:
      return ESTAT_INICIAL;

    case OMPLIR_TITOL_APARTAT: {
      return action.payload;
    }

    default:
      return state;
  }
};

export default titolApartat;

export const getTitolApartat = state => state.titolApartat;
